import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { CountdownModule } from 'ngx-countdown';
import { MatchdayRoutingModule } from './matchday-routing.module';
import { MatchdayComponent } from './matchday/matchday.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatchdaycontentComponent } from './matchdaycontent/matchdaycontent.component';
import { FreeentryformComponent } from './freeentryform/freeentryform.component';
import { CarParkingComponent } from './car-parking/car-parking.component';
import { CountyChampionshipComponent } from './county-championship/county-championship.component';
import { VitalityBlastComponent } from './vitality-blast/vitality-blast.component';


@NgModule({
  declarations: [MatchdayComponent, MatchdaycontentComponent, FreeentryformComponent, CarParkingComponent, CountyChampionshipComponent, VitalityBlastComponent],
  imports: [
    CommonModule,
    MatchdayRoutingModule,
    FormsModule,
    SharedModule

  ]
  
})
export class MatchdayModule { }
